// 生成した静止画・動画を別タブのビューアページで開く。
//
// タブは生成完了時に開く (発注者指定 2026-07-23)。ユーザー操作から時間が
// 経っているとpopupブロックされることがあり、その場合はfalseを返すので
// 呼び出し側は従来のDLへフォールバックする。
// Blob URLにはファイル名情報がないため、ブラウザ標準の保存 (右クリック・Ctrl+S)
// では名前を指定できない。ビューア内の「保存」リンク (download属性) 経由で
// 従来と同じファイル名を付ける。

export type ViewerKind = "image" | "video";

// 「○○完成: ファイル名」リンクを作る。クリックでビューアタブを開く
// (クリックは新しいユーザー操作なのでpopupブロックされない)。
// hrefとdownload属性は中クリック・「名前を付けて保存」用に残す。
export function createViewerLink(options: {
    url: string;
    filename: string;
    kind: ViewerKind;
    label: string;
}): HTMLAnchorElement {
    const a = document.createElement("a");
    a.href = options.url;
    a.download = options.filename;
    a.textContent = `${options.label}: ${options.filename}`;
    a.addEventListener("click", (event) => {
        event.preventDefault();
        openViewer(options);
    });
    return a;
}

export function openViewer(options: {
    url: string;
    filename: string;
    kind: ViewerKind;
}): boolean {
    const tab = window.open("", "_blank");
    if (!tab) {
        return false; // popupブロック
    }
    const filename = escapeHtml(options.filename);
    const url = escapeHtml(options.url);
    // 動画は無音AACトラック付きのため、muted がないと自動再生が
    // ブロックされる (Chrome の autoplay policy)。ループはデフォルトOFFで
    // バーのチェックボックスから切替できる
    const media =
        options.kind === "video"
            ? `<video src="${url}" controls autoplay muted playsinline></video>`
            : `<img src="${url}" alt="${filename}" />`;
    const loopToggle =
        options.kind === "video"
            ? `<label><input type="checkbox" id="loop_toggle" />ループ再生</label>`
            : "";
    const script =
        options.kind === "video"
            ? `<script>
const video = document.querySelector("video");
const toggle = document.querySelector("#loop_toggle");
toggle.addEventListener("change", () => {
    video.loop = toggle.checked;
    if (toggle.checked && video.ended) {
        video.play();
    }
});
// autoplay属性だけでは開始しない環境があるため明示的に再生する
video.play().catch(() => {});
</script>`
            : "";
    writeDocument(
        tab,
        options.filename,
        `<div class="bar"><a href="${url}" download="${filename}">保存</a><span>${filename}</span>${loopToggle}</div>
        <div class="view">${media}</div>${script}`,
    );
    return true;
}

function writeDocument(tab: Window, title: string, body: string) {
    const html = `<!doctype html><html lang="ja"><head><meta charset="utf-8" />
<title>${escapeHtml(title)}</title>
<style>
html, body { margin: 0; height: 100%; background: #333333; color: #eeeeee;
    font: 13px sans-serif; }
body { display: flex; flex-direction: column; }
.bar { padding: 6px 12px; background: #222222; display: flex; gap: 14px;
    align-items: center; flex: none; }
.bar a { color: #88ccff; font-weight: bold; text-decoration: none;
    border: 1px solid #88ccff; border-radius: 4px; padding: 3px 14px; }
.bar a:hover { background: #335577; }
.bar label { display: flex; align-items: center; gap: 4px; cursor: pointer;
    user-select: none; }
.view { flex: 1; min-height: 0; display: flex; align-items: center;
    justify-content: center; }
.view img, .view video { max-width: 100%; max-height: 100%; }
</style></head><body>${body}</body></html>`;
    tab.document.open();
    tab.document.write(html);
    tab.document.close();
}

function escapeHtml(text: string) {
    return text
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
}
